module.exports = __webpack_public_path__ + "static/media/jcb.f4b7cd62.svg";